module.exports = __webpack_public_path__ + "static/img/icon_wfcl.11f6bf59.png";